module.exports = __webpack_public_path__ + "img/snow.3728cc2a.svg";